import Vue from 'vue'
import { mapState, mapMutations, mapActions } from 'vuex'
import { API_URL } from '@/config'

const mixins = Vue.mixin({

  computed: {
    ...mapState(['language', '_', 'settings', 'progress', 'response', 'del', 'massdel', 'authorized']),
  },

  methods: {

    ...mapMutations(['setProgress', 'clearResponse', 'setModal', 'setDetails', 'setManager', 'setClear', 'setDelete', 'setMassDelete', 'setUpload', 'setConflicts', 'setCopy', ]),
    ...mapActions(['showTooltip', 'hideTooltip']),
    ...mapActions('session_presentations', ['getAssignedPresentations']),

    showDetails(details) {
      this.setDetails({ model: details.model, id: details.id });
      this.setModal({ status: true, component: 'Details', class: 'large' });
    },

    showManager(abstract_id) {
      this.setManager({ abstract_id: abstract_id });
      this.setModal({ status: true, component: 'Manager', class: 'large' });
    },

    showConflicts(conflicts) {
      this.setConflicts({ model: conflicts.model, id: conflicts.id, type: conflicts.type });
      this.setModal({ status: true, component: 'Conflicts', class: 'large' });
    },

    confirmCopy(copy) {
      this.setCopy({ model: copy.model, id: copy.id });
      this.setModal({ status: true, component: 'Copy', class: 'small' });
    },

    confirmClear(clear) {
      this.setClear({ model: clear.model, id: clear.id, items: clear.items, ids: clear.ids });
      this.setModal({ status: true, component: 'Clear', class: 'small' });
    },

    confirmDelete(del) {
      this.setDelete({ model: del.model, id: del.id, action: del.action });
      this.setModal({ status: true, component: 'Delete', class: 'large' });
    },

    confirmMassDelete(massdel) {
      this.setMassDelete({ model: massdel.model, ids: massdel.ids, action: massdel.action  });
      this.setModal({ status: true, component: 'MassDelete', class: 'large' });
    },

    showUpload(upload) {
      this.setUpload({ model: upload.model });
      this.setModal({ status: true, component: 'Upload', class: 'large' });
    },

    async clearItems() {
      await Vue.axios.delete(API_URL + '/' + this.clear.model + 's/' + this.clear.id + '/' + this.clear.items + '/' + this.clear.ids);
      this.$store.commit('setProgress', false);
      this.$store.commit('closeModal');
      await this.getAssignedPresentations();
    },

    async deleteItem() {
      const route = this.del.model + 's';
      const action = this.del.action;
      await Vue.axios.delete(API_URL + '/' + route + '/' + this.del.id);
      this.$store.commit('setProgress', false);
      this.$store.commit('closeModal');
      if (action.path !== this.$route.path) {
        this.$router.push(action.path);
      } else {
        this.$store.commit(route + '/clearList');
        this.$store.dispatch(route + '/getList');
      }
    },

    async deleteItems() {
      const route = this.massdel.model;
      const action = this.massdel.action;
      await Vue.axios.delete(API_URL + '/mass/' + this.massdel.model, {
        params: {
          ids: this.massdel.ids,
        }
      });
      this.$store.commit('setProgress', false);
      this.$store.commit('closeModal');
      if (action.path !== this.$route.path) {
        this.$router.push(action.path);
      } else {
        this.$store.commit(route + '/clearList');
        this.$store.dispatch(route + '/getList');
      }
    },

    formatDate(day) {
      return this._.date_format_schedule
        .replace('&day', this._[day.day_name])
        .replace('&d', day.day)
        .replace('&month', this._[day.month_name])
        .replace('&y', day.year) || '';
    },

    formatTime(time) {
      let hours = '0' + Math.floor((time / 60) / 60);
      let minutes =  '0' + ((time / 60) % 60);
      return hours.substr(-2) + ':' + minutes.substr(-2);
    },

    formatPerson(person, area) {
      if (person.country_code && this.settings[area].skip_countries && this.settings[area].skip_countries.split(',').includes(person.country_code)) person.country_code = null;
      let name = '';
      if (this.settings[area].name === 'first-last') name = person.first_name + ' ' + person.last_name;
      if (this.settings[area].name === 'last-first') name = person.last_name + ', ' + person.first_name;
      if (this.settings[area].title === '1') name = person.title ? person.title  + ' ' + name : name;
      const affiliation = [];
      if (this.settings[area].affiliation) {
        this.settings[area].affiliation.split(',').forEach((attribute) => {
          let value = person[attribute];
          if (attribute === 'country') {
            value = person.country_code ? this._[person.country_code] : '';
          }
          if (value) affiliation.push(value);
        });
      }
      const brackets = (this.settings[area].brackets === '1') ? [' (', ')'] : [', ', ''];
      return name + ((affiliation.length) ? brackets[0] + affiliation.join(', ') + brackets[1] : '');
    },

    satisfyDependency(dependency, namespace) {
      if (!dependency) return true;
      dependency = dependency.split(':');
      const type = dependency[0];
      if (type === 'setting') {
        const area = dependency[1];
        const key = dependency[2];
        const value = dependency[3];
        return (this.settings[area][key] === value) ? true : false;
      }
      if (type === 'entity') {
        const column = dependency[1]
        const values = dependency[2] ? dependency[2].split(',').map(i => parseInt(i)) : null;
        return (values) ? values.includes(parseInt(this.$store.state[namespace].values[column])) : this.$store.state[namespace].values[column];
      }
      if (type === 'column') {
        const column = dependency[1];
        let value = dependency[2];
        return (dependency[2][0] === '!')
          ? this.$store.state[namespace].values[column] !== dependency[2].substring(1)
          : this.$store.state[namespace].values[column] === value;
      }
    },

    highlightText(text, highlight) {
      highlight = highlight.split(',').reduce((carry, term) => { if (term.trim() !== '*') carry.push(term.trim().replace('*', '')); return carry; }, []).join('|');
      return highlight
        ? text.replace(new RegExp('(' + highlight + ')', 'gi'), '<span class="highlight">$1</span>')
        : text;
    }

  }
})

export default mixins
